<template>
    <div class="container clearfix">
        <div class="registration-form">
            <fieldset>
                <legend>パスワードリセット</legend>
                <hr>
                <p>
                    パスワードリセット用のURLを送信します。<br>
                    登録済のメールアドレスを入力してください。
                </p>
                <div class="form-column">
                    <input name="email" class="form-control" placeholder="Email" id="email" maxlength="255" v-model="profile.email">
                </div>
            </fieldset>
            <div class="registration-btn">
                <button class="btn btn-primary" @click="requestResetPassword">送信</button>    
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import $userRepository from '../../backend/userRepository'

export default {
    data() {
        return {
            profile: {
                email: ''
            },
            errorMessage: '',
            validate_flag: false,
            response: null
        }
    },
    computed: {
        ...mapState({
            errorMessage: state => (state.auth.errorMessage)
        })
    },
    mounted() {
        this.$store.commit('auth/setErrorMessage', null)
    },
    methods: {
        async requestResetPassword() {
            this.validate();
            if(this.validate_flag) {
                this.validate_flag = false;
                return;
            }
            
            this.errorMessage = '';
            
            this.response = await $userRepository.requestResetPassword(this.profile.email);
            if(this.response.status === 200) {
                Message({  // 画面遷移中に消えないように、他のMessageコンポーネントとは少し設定を変えています
                    message: 'ご登録のアドレスに送られたメールから新しいパスワードを設定してください',
                    type: 'success',
                    duration: 0,
                    showClose: true
                });
                this.$router.push({ path: '/'});
            }
            // バックエンドで検知したエラーはerrorMessageコンポーネントで表示する
        },
        // formではなくdataを利用してバックエンドに送信するため、フロントで検知したエラーはinput属性ではなく下記でバリデーションチェックを行う
        validate() {
            if (!this.profile.email) {
                Message({
                    message: 'メールアドレスが未入力です',
                    type: 'error'
                });
                this.errorMessage = 'メールアドレスが未入力です';
                this.validate_flag = true;
                return;
            }
            if (!this.profile.email.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.+-]{1,}\.[A-Za-z0-9]{1,}$/)) {
                Message({
                    message: 'メールアドレスの形式が不正です',
                    type: 'error'
                });
                this.validate_flag = true;
            }
        }
    }
}
</script>

 <style scoped>
 .registration-form {
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
     width: 80%;
     max-width: 400px;
 }
 .form-column {
     margin-bottom: 10px;
 }
 .registration-btn {
     text-align: center;
     margin: 10px;
 }

 </style>